



























import { Component, Vue } from 'vue-property-decorator'
import GlobalMixins from '../mixins'

@Component
export default class Embed extends GlobalMixins {

	get url(): string {
		return `${window.location.protocol}//${window.location.host}?${this.slugify(this.dictionary.statement.tabTitle)}=${(this.$route.params.id)}`
	}
}
